import {styled} from '@mui/system'

export const ExportStyled = styled('div')(({theme}) => ({
  marginTop: theme.spacing(8),

  '.table-header': {
    margin: `${theme.spacing(10)} ${theme.spacing(5)}`
  }
}))
